<template>
    <div class="opportunity">
        <v-icon v-on:click="editOpportunity()">fa-edit</v-icon>
        <div class="card-info-row">
            <div class="card-info avatar">
                    <v-img class="card-avatar" :src="opportunity.bankLogo" />
                <div class="card-info">
                    <label><b>Banco</b></label>
                    <p>{{ opportunity.bankName }}</p>
                </div>
            </div>
        </div>
        <div class="card-info-row" v-if="opportunity.bankChartName">
            <div class="card-info">
                <label><b>Tabela</b></label>
                {{ opportunity.bankChartName }}
            </div>
        </div>
        <div class="card-info-row">
            <div class="card-info" v-if="opportunity.typeName">
                <label><b>Tipo</b></label>
                {{ opportunity.typeName }}
            </div>
            <div class="card-info" v-if="opportunity.interest != 0">
                <label><b>Taxa</b></label>
                {{ opportunity.interest / 100 | fmtPercent }}
            </div>
            <div class="card-info" v-if="!opportunity.term || !opportunity.installment">
                <label><b>Parcelas</b></label>
                <p>{{ opportunity.term }} de {{ opportunity.installment | fmtMoney }}</p>
            </div>
            <div class="card-info">
                <label><b>Valor</b></label>
                {{ opportunity.amount | fmtMoney }}
            </div>
        </div>
        <div class="card-info-row" v-if="opportunity.statusName">
            <div class="card-info">
                <label>
                    <div class="type-badge">
                        {{ getKind }}
                    </div>
                </label>
                {{ opportunity.statusName }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customerId: {
            type: Number,
            required: true
        },
        opportunity: {
            type: Object,
            required: true
        },
    },

    computed: {
        getKind() {
            switch(this.opportunity.kind) {
                case 'OPT':
                    return 'Oportunidade';
                case 'EST':
                    return 'Esteira';
                case 'CTT':
                    return 'Contrato';
                default:
                    return 'Pago';
            }
        },
    },

    methods: {
        editOpportunity(fromContract = false) {
			window.getApp.showModal('Propostas', {
				doneCallback: () => { },
				props: {
					obj: 'contract',
					dataKey: this.opportunity.id,
					customerId: this.customerId,
					formDataParam: fromContract ? { ...this.opportunity, typeId: this.opportunity.opportunityGroupId ? this.opportunity.opportunityGroupId : this.opportunity.selectedOperation == 'P' ? 30 : 10 } : {},
					statusId: 0
				},
				modalWidth: 600,
			});
		},
    }
}
</script>

<style scoped>
    p {
        margin: 0;
    }
    .opportunity {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 15px;
        border-radius: 5px;
        background-color: #0000ff0c;
        gap: 10px;
        position: relative;
    }

    .opportunity > i {
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
        font-size: 22px;
    }

    .card-info {
        display: flex;
        flex-direction: column;
    }

    .card-info > label {
        font-size: 12px;
        color: var(--gray-color);
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
    }

    .card-info.avatar {
        flex-direction: row;
        align-items: center;
    }

    .card-info-row {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .card-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: bold;
        color: var(--white-color);
        margin-right: 10px;
    }

    .card-info span {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }

    .type-badge {
        font-size: 12px;
        padding: 2px 5px;
        border-radius: 5px;
        background-color: var(--secondary-color);
        color: var(--white-color);
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Opportunity.vue